var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEgt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 542,
    viewBox: "0 0 542 542",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.52 136.766C16.6641 165.493 -215.442 504.56 484.943 420.703C435.607 418.772 -128.167 412.842 255.537 136.766H255.52Z",
    fill: "#A9C945"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M338.455 122.567C436.718 73.9143 647.856 140.665 426.994 326.698C206.133 512.732 662.45 159.531 338.455 122.567Z",
    fill: "#A9C945"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275.209 352.177C322.494 352.177 360.826 313.845 360.826 266.56C360.826 219.275 322.494 180.943 275.209 180.943C227.924 180.943 189.592 219.275 189.592 266.56C189.592 313.845 227.924 352.177 275.209 352.177Z",
    fill: "#A9C945"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgt);
export default __webpack_public_path__ + "static/media/egt.761e839a5c8292853c3d1b5a2f7b0820.svg";
export { ForwardRef as ReactComponent };